module.exports = __webpack_public_path__ + "static/img/j_1@2x.5be7a01.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/j_1@2x.png
// module id = F0ZT
// module chunks = 2